var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRedShieldWithV = function SvgRedShieldWithV(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5u84gsuqna",
    d: "M0 .16h34.513v47.342H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "d89n8iyvzb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5u84gsuqna"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.617 25.857c0 6.077-3.406 10.554-13.36 17.323-9.954-6.768-13.36-11.246-13.36-17.323V10.45c4.95-.527 8.912-2.21 13.36-5.65 4.447 3.44 8.41 5.123 13.36 5.65v15.406zM33.54 6.789c-5.854-.133-9.88-1.542-15.55-6.37a1.131 1.131 0 0 0-.732-.26c-.265 0-.528.087-.732.26C10.855 5.247 6.83 6.656.975 6.79.437 6.801 0 7.23 0 7.76v18.098c0 8.798 5.976 14.49 16.447 21.423.223.148.516.222.81.222.293 0 .586-.074.81-.222 10.47-6.932 16.446-12.625 16.446-21.423V7.759a.984.984 0 0 0-.974-.97z",
    fill: "#C40000",
    mask: "url(#d89n8iyvzb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 21.937a1.124 1.124 0 0 0-1.442.011l-1.267 1.136a.824.824 0 0 0 .013 1.267l5.213 4.5c.052.044.109.082.169.116.396.235.941.2 1.292-.108l9.105-8.005a.825.825 0 0 0 0-1.268l-1.28-1.125a1.124 1.124 0 0 0-1.44 0l-7.128 6.267-3.235-2.791z",
    fill: "#C40000"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedShieldWithV, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red_shield_with_v.b89869aa.svg";
export { ForwardRef as ReactComponent };